import { useState, useContext } from 'react'
import { useLocation } from "react-router";
import { getApplication } from 'api/api';
import { InfiniteScroll, Empty, SpinLoading } from 'antd-mobile'
import { UserContext } from 'utils/getContext';
import { progressCheck, reviewType } from 'utils/constant';
import BpmToast from 'components/BpmToast';
import nodata from "static/images/nodata.svg";
import 'static/css/progressCheck.css';

const { SUCCESS, FAIL, ING } = reviewType
const { STATUS, VIESTATUS, PUBLSTATUS, RELEASTATUS } = progressCheck

/** 
 * 申请进度查询页
 */
function ProgressCheck() {

  const { userInfo } = useContext(UserContext)
  const { state: { title } } = useLocation()
  const newTitle = `${title} · 申请进度查询`
  const { idNum } = userInfo ?? ''

  const [detail, setDetail] = useState([])     // 数据
  const [hasMore, setHasMore] = useState(true) // 是否加载更多
  const [loading, setLoading] = useState(true) // 是否显示加载圈
  const [pageNo, setPageNo] = useState(1)      // 页码

  /** 获取申请进度详情接口 */
  const loadMore = async () => {
    // 仅在第一次加载时显示加载圈，否则会导致页面一直刷新
    // if (pageNo !== 1) setLoading(false)
    try {
      const { data, success, msg } = await getApplication(idNum, pageNo)
      const { applicationProgressInfos } = data
      if (success) {
        setPageNo(pageNo + 1)
        setDetail([...detail, ...applicationProgressInfos])
        // setDetail([])
        setHasMore(applicationProgressInfos.length > 0)
      } else {
        BpmToast(msg)
      }
    } catch {
      console.error('-------> ProgressCheck:loadMore <-------')
    } finally {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }

  /** 不同的结果用不同的颜色显示 */
  const colorType = (type) => {
    switch (type) {
      case SUCCESS:
        return '#00cf00'
      case FAIL:
        return 'red'
      case ING:
        return '#2773C5'
      default:
        return ''
    }
  }

  /**根据字段名称返回数据转换后的结果：0->进行中 */
  const tranResult = (label, result) => {
    switch (label) {
      case STATUS:         // 认定结果
        switch (result) {
          case SUCCESS:
            return '已认定'
          case FAIL:
            return '未认定'
          default:
            return '认定中'
        }
      case VIESTATUS:      // 申请结果
        switch (result) {
          case SUCCESS:
            return '已通过'
          case FAIL:
            return '未通过'
          default:
            return '待审核'
        }
      case PUBLSTATUS:     // 公示结果
        switch (result) {
          case SUCCESS:
            return '公示成功'
          case FAIL:
            return '公示失败'
          default:
            return '待公示'
        }
      case RELEASTATUS:    // 补贴情况
        switch (result) {
          case SUCCESS:
            return '发放成功'
          case FAIL:
            return '发放失败'
          default:
            return '待发放'
        }
      default:
        return result
    }
  }

  /** 页面数据渲染 */
  const showInfo = [
    {
      title: '就业困难人员认定',
      label: 'status'
    },
    {
      title: '社保补贴申请时间',
      label: 'appTime'
    },
    {
      title: '社保补贴申请',
      label: 'vieStatus'
    },
    {
      title: '社会公示',
      label: 'publStatus'
    },
    {
      title: '补贴拨付',
      label: 'releaStatus'
    },
  ]

  return (
    <div className="pc-root">
      <div className='pc-title'>
        {newTitle}
      </div>
      {
        loading
          ?
          (
            <div className='pc-loading'>
              <SpinLoading className="pc-spinLoading" />
            </div>
          )
          :
          (
            detail?.length !== 0 ? (
              detail.map((items, index) =>
                <div className='pc-content' key={index}>
                  {
                    showInfo.map(item => (
                      <div className='pc-border' key={item.title}>
                        <div><b>{item.title}</b></div>
                        <div style={{ color: colorType(items[item.label]) }}>{tranResult(item.label, items[item.label])}</div>
                      </div>
                    ))
                  }
                </div>
              )
            )
              :
              (
                detail?.length === 0 && (
                  <Empty
                    className='pc-empty'
                    image={nodata}
                    description='暂无数据'
                    imageStyle={{ width: 128 }}
                  />
                )
              )
          )
      }
      < InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
    </div>
  )
}

export {
  ProgressCheck
}